
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchCMARegisteredUSer = createAsyncThunk(
  'fetchCMARegisteredUSer',
  async ({ jwtBearer }) => {
    const response = await fetch(`${BASE_URL}cma/registered/users/`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
      }
    })
    return response.json()
  }
)

const cmaRegisteredUserSlice = createSlice({
  name: 'cmaRegisteredUsers',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchCMARegisteredUSer.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchCMARegisteredUSer.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchCMARegisteredUSer.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default cmaRegisteredUserSlice.reducer
